/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations

==========================================================================================*/

export default {

  SET_PARTNERS (state, data) {
    state.partners = data
  },

  SET_TAXES (state, data) {
    state.taxes = data
  },
  SET_GROUP_PAYMENTS (state, data) {
    state.groupPayments = data
  },
  SET_REGION_MUNICIPALITIES (state, data) {
    state.regionMunicipalities = data
  },
  SET_DETAIL_PAYMENTS (state, data) {
    state.detailsPayments = data
  },
  SET_TERMINAL_PAYMENTS (state, data) {
    state.terminalPayments = data
  },
  SET_INVOICE (state, data) {
    state.invoice = data
  }


}
